import React, { useState, useRef, useEffect } from 'react';
import { useWallet } from './WalletContext';
import { CHAIN, shortAddress, addressUrl } from './config';

// Header wallet control: connect CTA, or address pill + dropdown when connected.
export default function WalletButton() {
    const { address, balance, chainOk, connecting, hasWallet, connect, disconnect, ensureChain } = useWallet();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', onDoc);
        return () => document.removeEventListener('mousedown', onDoc);
    }, []);

    if (!address) {
        return (
            <button className="bp-wallet-btn" onClick={connect} disabled={connecting}>
                <span className="bp-wallet-dot" />
                {connecting ? 'Connecting…' : hasWallet ? 'Connect Wallet' : 'Get BirrWallet'}
            </button>
        );
    }

    return (
        <div className="bp-wallet-wrap" ref={ref}>
            <button className={`bp-wallet-btn bp-wallet-connected ${chainOk ? '' : 'bp-wallet-wrongchain'}`} onClick={() => setOpen(!open)}>
                <span className={`bp-wallet-dot ${chainOk ? 'live' : 'warn'}`} />
                <span className="bp-wallet-addr">{shortAddress(address)}</span>
                {balance !== null && chainOk && <span className="bp-wallet-bal">{balance} BRC</span>}
            </button>
            {open && (
                <div className="bp-wallet-menu">
                    {!chainOk && (
                        <button className="bp-wallet-menu-item warn" onClick={() => { ensureChain(); setOpen(false); }}>
                            Switch to {CHAIN.name}
                        </button>
                    )}
                    <a className="bp-wallet-menu-item" href={addressUrl(address)} target="_blank" rel="noreferrer">
                        View on Explorer ↗
                    </a>
                    <button className="bp-wallet-menu-item" onClick={() => { navigator.clipboard && navigator.clipboard.writeText(address); setOpen(false); }}>
                        Copy Address
                    </button>
                    <button className="bp-wallet-menu-item danger" onClick={() => { disconnect(); setOpen(false); }}>
                        Disconnect
                    </button>
                </div>
            )}
        </div>
    );
}
